import React, { useEffect } from 'react';
import ProfileMenu from '../Layouts/ProfileMenu';
import CounselingNote from './CounselingNote';
import TreatmentPlan from './TreatmentPlan';
import { useNavigate, useParams } from 'react-router-dom';
import { DEFAULT_LOCAL_PATH } from '../../constents';

function Notes() {
  const { page } = useParams();
  const navigate = useNavigate();
  const handletabs = (tab) => {
    if (tab === 'counNote') {
      navigate(`${DEFAULT_LOCAL_PATH}/notes/counNote`);
    } else {
      navigate(`${DEFAULT_LOCAL_PATH}/notes/treatPlan`);
    }
  };
  useEffect(() => {
    if (!page) navigate(`${DEFAULT_LOCAL_PATH}/notes/counNote`);
  }, [page, navigate]);
  return (
    <>
      {(() => {
        if (page === 'counNote' || page === 'treatPlan') {
          return (
            <>
              <ProfileMenu handletabs={handletabs} activeTab={page} />
              {(page === 'counNote' && <CounselingNote />) ||
                (page === 'treatPlan' && <TreatmentPlan />)}
            </>
          );
        }
      })()}
    </>
  );
}

export default Notes;
